module.exports = __webpack_public_path__ + "static/media/java_logo.733edd9d.svg";